import { render, staticRenderFns } from "./RequestThankYouPage.vue?vue&type=template&id=206183b8&scoped=true"
import script from "./RequestThankYouPage.vue?vue&type=script&lang=js"
export * from "./RequestThankYouPage.vue?vue&type=script&lang=js"
import style0 from "./RequestThankYouPage.vue?vue&type=style&index=0&id=206183b8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "206183b8",
  null
  
)

export default component.exports